import React, { useMemo, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Button, Content, IconUtil, Pane, Text } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import { format } from 'date-fns';
import { Project } from '@leverege/api-redux';
import S from './InactivityScreen.css';
import Util from "./Util.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.support.MaintenanceScreen');
const DATE_FORMAT_STRING = "EEEE MMMM do 'at' p";
function MaintenanceScreen(props) {
  const {
    title,
    msg,
    url,
    button,
    image,
    projectId,
    activeMaintenanceEvent
  } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    if (!activeMaintenanceEvent) {
      dispatch(Project(projectId).activeMaintenanceEvents().list());
    }
  }, [activeMaintenanceEvent]);
  const applicationName = Config.get('MaintenanceScreen', 'applicationName', 'Application');
  const returnTime = activeMaintenanceEvent ? format(new Date(activeMaintenanceEvent.endTime), DATE_FORMAT_STRING) : 'soon';
  let mTitle = title === undefined ? Config.get('MaintenanceScreen', 'title', t('title', {
    applicationName
  })) : title;
  const mMsg = msg === undefined ? Config.get('MaintenanceScreen', 'message', t('message', {
    applicationName,
    returnTime
  })) : msg;
  const mButton = button === undefined ? Config.get('MaintenanceScreen', 'button', t('button')) : button;
  let mUrl = url === undefined ? Config.get('MaintenanceScreen', 'link', () => localStorage.getItem('lastActivePage') || '/') : url;
  const mImg = image === undefined ? Config.get('MaintenanceScreen', 'image', 'fa fa-fw fa-wrench'
  // 'https://molten-ui-assets.storage.googleapis.com/maintenance.png'
  ) : image;
  const img = useMemo(() => {
    if (Array.isArray(mImg)) {
      return mImg[Math.floor(Math.random() * mImg.length) % mImg.length];
    }
    return mImg;
  }, [mImg]);
  if (typeof mUrl === 'function') {
    mUrl = mUrl();
  }
  if (typeof mTitle === 'string') {
    mTitle = /*#__PURE__*/_jsx(Text, {
      variant: "maintenanceTitle|title",
      children: mTitle
    });
  }
  return /*#__PURE__*/_jsx(Content, {
    horizontal: true,
    variant: "editor",
    children: /*#__PURE__*/_jsx(Content.Area, {
      variant: "maintenanceScreen",
      className: S.area,
      children: /*#__PURE__*/_jsxs(Pane, {
        variant: "maintenanceScreenContent",
        className: S.content,
        children: [mImg && /*#__PURE__*/_jsx("div", {
          className: S.fontIcon,
          children: IconUtil.create(img, {
            width: '80%'
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [mTitle, /*#__PURE__*/_jsx(Text, {
            variant: "maintenanceCaption|caption",
            children: mMsg
          }), mUrl && window?.Intercom ? /*#__PURE__*/_jsx(Button, {
            variant: "linkNoPad|link",
            className: S.continue,
            onClick: () => {
              window.location.href = '/';
            },
            children: mButton
          }) : /*#__PURE__*/_jsx(Text, {
            variant: "subtitle",
            children: t('subtitle')
          })]
        })]
      })
    })
  });
}
export default connect(state => {
  const molten = window.Molten;
  const prjId = molten.get('api').options.projectId;
  return {
    activeMaintenanceEvent: Util.getActiveMaintenanceEvent(state.maintenanceEvents.active?.[prjId]?.maintenanceEvents),
    projectId: prjId
  };
})(MaintenanceScreen);